import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import PropTypes from 'prop-types';

import { CHANGEVERSIONBUILD } from '../dataLib';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import DoneIcon from '@material-ui/icons/Done';

//components:
import userManager from '../userManager';
import { drawerOptions, getDrawerOptions } from '../constants/drawer_options';
import * as config from '../constants/configuration';

//actions:
import { changeSelectedSection, setSections, openDialog, setSaveState, setUserProfileUsuarioCentro } from '../actions';
import { setCentroDia } from '../actions/centro_dia_actions';
import { ArrowRightSharp, RemoveShoppingCartSharp } from '@material-ui/icons';


const styles = theme => ({

    appBar: {
        position: 'fixed',
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
    },
    loginContainer: {
        padding: 0,
        marginRight: 30,
        height: 'inherit',
    },
    divButtons: {
        marginLeft: 'auto'
    },
    dashboardTitle: {
        padding: 0,
        fontSize: 16,
        marginLeft: 30,
        height: 'inherit',
    },
    centrodia: {
        width: 420,
        height: 'inherit',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    centro: {
        overflow: 'hidden',
        maxWidth: 265,
        fontSize: 16,
    },
    dia: {
        fontSize: 16,
    },
    user: {
        margin: theme.spacing(1),
    },
    topHeader: {
        backgroundColor: 'black',
        color: 'white',
        height: 35,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

    },
    bottomHeader: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 11,
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: `transparent transparent #a2398d`,
    },
    tab: {
        border: '11px solid transparent',
        color: 'black',
        focus: {
            outline: 'none',
            border: 0
        },
        // outline: 'none'
    },
    bigIndicator: {
        backgroundColor: theme.palette.secondary,
        height: 7,
    },
    selectCentro: {
        //color: 'white',
        backgroundColor: 'white',
        // border: '1px solid',
        // borderColor: 'white',
    }

});

class IlusionaHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: window.location.kd ? "NEURITE" : process.env.REACT_APP_CLIENT,
            menuOpen: false,
            anchorEl: null,
            tabValue: 0,
            showSelect: false,
            centroProfile: 0
        };

    };

    login = () => {
        userManager.signinRedirect();
    };

    openUserMenu = (event) => {
        this.setState({ ...this.state, anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ ...this.state, anchorEl: null });
    };

    handleTabChange = (event, value) => {
        if (this.props.saveState.pending) {
            this.props.openDialog('ConfirmationDialog', {
                message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                acceptHandler: () => {
                    this.props.setSaveState(false);
                    this.setState({ ...this.state, tabValue: value });
                    this.props.changeSelectedSection(value);
                }
            }, 'ilusiona-header-confirmation-message', false, 'sm');
        }
        else {
            this.setState({ ...this.state, tabValue: value });
            this.props.changeSelectedSection(value);
        }
    };

    componentDidMount = () => {
        if (config.AUTH) {
            if (this.props.userProfile.profile.id !== undefined) {
                //this.props.setSections(drawerOptions['Admin']);
                if (this.props.userProfile.selectedCentroProfile) {
                    this.props.setSections(getDrawerOptions(this.props.userProfile.selectedCentroProfile.iPerfil, this.props.user.profile.sub, this.props.userProfile.kd))
                }
            }
        }
        else {
            this.props.setSections(drawerOptions['Admin']);
        }
    };

    componentDidUpdate = (prevProps) => {
        
        // if (this.props.user !== undefined && this.props.user !== prevProps.user) {
        //     CHANGEVERSIONBUILD(this.props.user);
        // }

        if (this.props.userProfile.profile.id !== undefined) {

            if (this.props.userProfile.selectedCentroProfile && this.props.userProfile.selectedCentroProfile !== prevProps.userProfile.selectedCentroProfile) {

                this.props.setSections(getDrawerOptions(this.props.userProfile.selectedCentroProfile.iPerfil, this.props.user.profile.sub, this.props.userProfile.kd));
                if ( this.props.userProfile.kd ) { // fbp_kd
                    this.props.setCentroDia(this.props.userProfile.kd.centro_id, undefined, false);
                } else {
                    this.props.setCentroDia(this.props.userProfile.selectedCentroProfile.centroId, undefined, false);
                }

                // if ((prevProps.userProfile.profile.id !== undefined && this.props.userProfile.profile.id !== prevProps.userProfile.profile.id)
                //     || (prevProps.userProfile.profile.id === undefined)) {
                this.setState({ ...this.state, centroProfile: this.props.userProfile.selectedCentroProfile.id, tabValue: 0 });
                // }
            }
        }
    };

    renderSections = () => {

        const { classes } = this.props;

        return Object.keys(this.props.section.sections).map((section, i) => {
            return (<Tab className={classes.tab} key={i} label={section} />)
        });
    };

    handleSelectChange = (event) => {
        this.setState({ ...this.state, centroProfile: event.target.value });
    }

    onClickSaveCentro = () => {
        this.props.setUserProfileUsuarioCentro(this.props.userProfile.profile.usuarioCentro.findIndex(uc => uc.id === this.state.centroProfile));
        this.setState({ ...this.state, showSelect: false });
    }

    openDialogChangePassword = ()=>{
        this.props.openDialog('ChangePasswordDialog', {
            acceptHandler: () => {
            },
            user: this.props.user,
            userProfile: this.props.userProfile,
        }, 'change_password', false, 'sm');
    }

    render() {
        const { classes } = this.props;
        const { anchorEl, tabValue } = this.state;

        let date = '';
        if (!this.props.user) return (<div></div>);

        if (this.props.centroDiaSelected.dia) {
            const dt = new Date(this.props.centroDiaSelected.dia.slice(0, 10));
            //date = dt.toLocaleDateString('es-ES', {dateStyle: 'medium', month: 'numeric'});
            date = dt.toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
        }

        let pjson = require("../../package.json");

        return (
            <AppBar position="static" className={classes.appBar}>

                <div className={classes.topHeader}>

                    {this.props.userProfile.kd ? 
                        <div className={classes.dashboardTitle}>
                            <a href="https://www.neuritelab.com/inventario-versiones" target="_blank"><Typography variant="h6" color="inherit" > {'v. '+pjson.version} </Typography></a>
                        </div>
                    :
                        <div className={classes.dashboardTitle}>
                            <a href="https://www.ilusiona.com/"><Typography variant="h6" color="inherit" > {this.state.name} </Typography></a>
                        </div>
                    }
                    
                    {this.props.userProfile.profile.id && this.props.userProfile.kd == null ?
                        <div className={classes.centrodia}>
                            {this.props.userProfile.profile.usuarioCentro.length > 1 ?
                            <IconButton aria-label="add an alarm" onClick={
                                () => {
                                    this.state.showSelect ?
                                        this.onClickSaveCentro() :
                                        this.setState({ ...this.state, showSelect: true });
                                }
                            }>
                                {this.state.showSelect ? <DoneIcon style={{ color: "white" }} /> : <SettingsIcon style={{ color: "white" }} />}
                            </IconButton>
                            :null
                            }
                            {!this.state.showSelect ? <Typography
                                className={classes.centro}
                                variant="subtitle2"
                                color="inherit"
                            >
                                {this.props.centroDiaSelected.centro ? this.props.centroDiaSelected.centro.centro : ''}
                            </Typography> : null}
                            <Select className={classes.selectCentro}
                                variant='outlined'
                                hidden={!this.state.showSelect}
                                value={this.state.centroProfile}
                                onChange={this.handleSelectChange}
                                name={'usuarioCentroSelect'}
                            >
                                {this.props.userProfile.profile.usuarioCentro.filter(uc => uc.centro.activo === 1).map((c, i) => {
                                    return (<MenuItem key={'usuario_centro_' + i} value={c.id}>{c.centro.descr}</MenuItem>);
                                })}

                            </Select>

                            <Typography className={classes.dia} variant="subtitle2" color="inherit">
                                {date}
                            </Typography>
                        </div>
                        : ''}

                        {this.props.userProfile.profile.id && this.props.userProfile.kd ?
                        <div className={classes.centrodia}>
                            <Typography className={classes.dia} variant="subtitle2" color="inherit">
                                {date}
                            </Typography>
                        </div>
                        : ''}


                    <Button
                        color="inherit"
                        className={classes.loginContainer}
                        aria-owns={anchorEl ? 'user-menu' : null}
                        aria-haspopup="true"
                        onClick={this.props.user ? this.openUserMenu : this.login}
                    >
                        {this.props.user ? this.props.user.profile.name : "Login"}
                    </Button>

                    <Menu
                        id="user-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                    >
                        {/* <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                        <MenuItem onClick={this.handleClose}>My account</MenuItem> */}
                        <MenuItem onClick={() => this.openDialogChangePassword()}>Cambiar contraseña</MenuItem>
                        <MenuItem onClick={() => userManager.signoutRedirect()}>Logout</MenuItem>
                    </Menu>
                </div>


                <Toolbar className={classes.bottomHeader}>
                    <Tabs
                        classes={{ indicator: classes.bigIndicator }}
                        value={tabValue}
                        onChange={this.handleTabChange}
                        indicatorColor="secondary"
                        textColor="secondary"
                    >
                        {this.renderSections()}
                    </Tabs>
                </Toolbar>

            </AppBar>
        );
    };

};

IlusionaHeader.propTypes = {
    //state:
    section: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch:
    changeSelectedSection: PropTypes.func.isRequired,
    setSections: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        section: state.section,
        centroDiaSelected: state.centroDiaSelected,
        saveState: state.saveState,
        userProfile: state.userProfile
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeSelectedSection,
        setSections,
        openDialog,
        setCentroDia,
        setUserProfileUsuarioCentro,
        setSaveState,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(IlusionaHeader)));